import { normalizeCurrentMobileRoute } from '@/config/tenant-route';
import { LocaleProvider } from '@/i18n';
import { setEnumLabelTFunction } from '@ts-max/enum';
import { t } from 'i18next';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Root from './Root';
import './checkVisibility.polyfill';
import './main.less';

setEnumLabelTFunction(t as any);

const initialRouteContext = normalizeCurrentMobileRoute();

/* 在 React 18 中，开发模式 + 严格模式下，React 会故意调用两次组件的挂载和卸载，以检查副作用是否安全 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LocaleProvider>
      <BrowserRouter basename={initialRouteContext.basename}>
        <Root />
      </BrowserRouter>
    </LocaleProvider>
  </StrictMode>,
);
